<template>
  <div class="shipments-page">
    <div class="flex items-center justify-between">
      <h2>{{$t('Boxes')}}</h2>
      <vs-button v-if="this.$store.state.AppActiveUser.userRole === 'fc-operations-supervisor'" @click="openBoxModal()" color="primary" icon-pack="feather" icon="icon-plus" size="large"></vs-button>
    </div>
    <shipblu-table
        :sst="true"
        multiple
        v-model="selected"
        pagination
        :max-items="maximumItems"
        @search="handleSearch"
        @keyup.enter.native="handleSearch"
        search
        :data="boxes"
        :tableLoader="tableLoader"
      >
      <template slot="header">
        <div class="lg:w-auto w-full md:mt-0 lg:flex grid grid-cols-3 gap-2 items-center">
          <vs-button @click="printQrCode()">{{$t('Print Qr Code')}}</vs-button>
          <p>{{$t('Not Empty')}}</p>
          <vs-switch name="fragile" v-model="empty"/>
          <p>{{$t('All')}}</p>
        </div>
      </template>

      <template slot="thead">
        <shipblu-th>{{$t('ID')}}</shipblu-th>
        <shipblu-th>{{$t('Shelf')}}</shipblu-th>
        <shipblu-th>{{$t('Size')}}</shipblu-th>
        <shipblu-th>{{$t('Capacity')}}</shipblu-th>
        <shipblu-th>{{$t('No. Products')}}</shipblu-th>
        <shipblu-th>{{$t('Actions')}}</shipblu-th>
      </template>

      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <shipblu-td :data="data[indextr].id">
            {{ data[indextr].ops_id }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].storage_location">
            {{ data[indextr].storage_location ? data[indextr].storage_location.ops_id : 'N/A' }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].storage_size">
            {{ data[indextr].storage_size }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].capacity">
            {{ data[indextr].capacity }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].numberOfProducts">
            {{ data[indextr].number_of_products }}
          </shipblu-td>

          <shipblu-td>
              <vs-dropdown
                vs-trigger-click
                class="dd-actions cursor-pointer"
                @click="selected = []"
              >
                <vs-button
                  type="border"
                  size="small"
                  icon-pack="feather"
                  icon="icon-more-horizontal"
                  class="mr-2"
                >
                </vs-button>
                <vs-dropdown-menu style="width: 190px">
                  <vs-dropdown-item
                    @click="printQrCode(data[indextr])"
                  >
                    <span class="flex items-center">
                      <feather-icon
                        icon="PrinterIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <span>{{$t('Print QR Code')}}</span>
                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
             </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <shipblu-pagination :maximumItems="maximumItems" :noOptions="true" :totalRows="totalRows" :currentPage="currentPage" @currentPage="currentPage = $event" />
    <add-storage-unit v-if="$store.state.AppActiveUser.userRole === 'fc-operations-supervisor'" type="box" :storageModal="storageModal" @storageModal="storageModal = $event" @loadData="loadBoxes"></add-storage-unit>
    <qr-code-storage-units :storageUnit="storageUnit"></qr-code-storage-units>
  </div>
</template>

<script>
import ShipbluTable from '../../layouts/components/NewShipBluTable.vue'
import ShipbluTr from '../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../layouts/components/ShipBluTd.vue'
import common  from '@/assets/utils/common'
import {sendFulfillmentRequest} from '../../http/axios/requestHelper.js'
import AddStorageUnit from './components/AddStorageUnit.vue'
import QrCodeStorageUnits from './components/QrCodeStorageUnits.vue'
import ShipbluPagination from '../../layouts/components/ShipbluPagination.vue'

export default {
  components: {
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    AddStorageUnit,
    QrCodeStorageUnits,
    ShipbluPagination
  },
  data () {
    return {
      maximumItems: process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      storageModal: false,
      totalRows: 0,
      selected: [],
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      searchVal: '',
      offset: 0,
      boxes: [],
      searchInProgress: false,
      searchedValue: ' ',
      deleteData:{},
      tableLoader: false,
      storageUnit: [],
      empty: false
    }
  },
  methods: {
    removeAttribute (event) {
      event.preventDefault()
    },
    openBoxModal () {
      this.storageModal = true
    },
    handleSearch (search) {
      this.offset = 0
      this.currentPage = 1
      this.searchVal = search.target ? search.target.value : search
      return common.manageSearch(search, this.loadBoxesSearch)
    },
    loadBoxes () {
      this.searchInProgress = true
      this.tableLoader = true
      const query = `?offset=${this.offset}&search=${this.searchVal}&limit=${this.maximumItems}&show_empty_bins=${this.empty}`
      sendFulfillmentRequest(true, false, this, `api/v1/fc/boxes/${query}`, 'get', null, true,
        (response) => {
          this.boxes = response.data.results
          this.totalRows = response.data.count
          this.searchedValue = this.searchVal
          this.tableLoader = false
        }
      )
      this.searchInProgress = false
    },
    loadBoxesSearch () {
      if (this.searchInProgress || this.searchedValue === this.searchVal) {
        return
      }
      this.loadBoxes()
    },
    printQrCode (storage) {
      this.storageUnit = this.selected.length > 0 ? this.selected : [storage]
      setTimeout(() => {
        window.print()
      }, 500)
    }
  },
  watch: {
    empty () {
      this.offset = 0
      this.currentPage = 1
      this.loadBoxes()
    },
    currentPage () {
      this.offset = (this.currentPage - 1) * this.maximumItems
      this.$router.push({
        query: {
          page: this.currentPage
        }
      }).catch(() => {})
      this.loadBoxes()
    }
  },
  mounted () {
    this.$emit('setAppClasses', 'shipment-page')
  },
  created () {
    this.offset = (this.currentPage - 1) * this.maximumItems
    this.loadBoxes()
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
#order-label-print{
  display: none;
  visibility: hidden;
}
.con-pagination-table{
  display: none;
}
</style>